/**
 * DescriptionContent component.
 */
import AIIcon from '@components/atoms/icons/AI';
import Container from '@components/atoms/container/descriptionContentContainer';
import Context from '@shared/components/utils/context/descriptionContext';
import Info from '@components/elements/description/descriptionInfo';
import Synopsis from '@components/atoms/text/descriptionSynopsis';
import Tip from '@components/elements/description/descriptionTip';
import Title from '@components/atoms/text/descriptionTitle';
import { useContext } from 'react';
import { DELAY, DURATION } from '@shared/types/constants/animations';

/**
 * Renders the description content for the focused asset in a rail.
 */
export default function DescriptionContent() {
  const { metadata } = useContext(Context);
  const { displayAI, synopsis, title } = metadata ?? {};
  return (
    <Container
      delay={DELAY.DESCRIPTION_CONTENT}
      duration={DURATION.DESCRIPTION_CONTENT}
    >
      <Title>
        {displayAI ? <AIIcon /> : null} {title}
      </Title>
      <Info />
      <Synopsis>{synopsis}</Synopsis>
      <Tip />
    </Container>
  );
}
